import React from 'react';
import './TriggerActionTypeSelect.styl';

export default class TriggerActionTypeSelect extends React.Component {
  render() {
    return (
      <div className="trigger-action-type-container">
        <div className="trigger-action-type-select">
          <div className="trigger-action-type-select-item">
            <div className="title">Real Time</div>
            <p>When your trigger is matched an action should instantly take place</p>
            <button onClick={() => this.props.selectType('event')}>Respond Immediately</button>
          </div>

          <div className="trigger-action-type-select-item">
            <div className="title">Trend Measurement</div>
            <p>
              Measure matches of your trigger (either as a count, on average, or a percentage) over
              a period of time
            </p>
            <button onClick={() => this.props.selectType('trend')}>Track Trend</button>
          </div>
        </div>
      </div>
    );
  }
}
